
export class ValidationError
{
    field:string;
    message:string;
}
export interface IValidationRule
{
    validate(form:any,field:string,value:any):ValidationRuleResult
}
export class ValidationRuleResult
{
  errors:Array<ValidationError> = new Array<ValidationError>();
  static error(field:string, message:string):ValidationRuleResult
  {
      let vrr = new ValidationRuleResult();
      let vm = new ValidationError();
      vm.field = field
      vm.message = message;
      vrr.errors.push(vm);
      return vrr;
  }
}
export class ValidationField
{
   field:string;
   rules:Array<IValidationRule>;
}
export class EmailRule implements IValidationRule
{
    validate(form:any,field:string,value:any):ValidationRuleResult
    {
      var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (emailRex.test(value)) {
        return ValidationRuleResult.error(field,'Invalid Email')
      }
      return null;
    }
}
export class UrlRule implements IValidationRule
{
    validate(form:any,field:string,value:any):ValidationRuleResult
    {
      if(!value)
        return undefined;
      try {
        new URL(value);
        return null;
      } catch (_) {
        return ValidationRuleResult.error(field,'Invalid Url');
      }
      
    }
}
export class RequiredRule implements IValidationRule
{
    validate(form:any,field:string,value:any):ValidationRuleResult
    {
      return value ? null:ValidationRuleResult.error(field,'Required');
     
      
    }
}


export class ValidationHelper
{

      fields:Array<ValidationField> = new Array<ValidationField>();
      generalRules:Array<IValidationRule> = new Array<IValidationRule>();
      getFirstError(field:string,errors:Array<ValidationError>):string{
         if(errors  )
         {
                let result = errors.find(x=>x.field==field);
                if(result)
                {
                    return result.message;
                }
                
         }
         return null;
         
      }
      validateForm(form:any): ValidationRuleResult
      {
        let result = new ValidationRuleResult();
        this.fields.forEach(field=>{
            let vr = this.validateField(form,field.field,form[field.field]);
            result.errors = result.errors.concat(vr.errors)
        })
        this.generalRules.forEach(rule=>{
          let vr = rule.validate(form,null,null);
          if(vr)
          {
            result.errors = result.errors.concat(vr.errors)
          }
       })
       return result;
        
      }
      validateField(form:any,field:string,value:any): ValidationRuleResult
      {
          let fieldRule = this.fields.find(f=>f.field==field);
          if(!fieldRule)
          {
            return null;
          }
          let result = new ValidationRuleResult();
         
            fieldRule.rules.forEach(rule=>{
               let vr = rule.validate(form,field,value);
               if(vr)
               {
                result.errors = result.errors.concat(vr.errors)
               }
            })
          
          return result;
      }
}

/*

 // function that verifies if a string has a given length or not
  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }
  // function that verifies if two strings are equal
  compare(string1, string2) {
    if (string1 === string2) {
      return true;
    }
    return false;
  }
  // function that verifies if value contains only numbers
  verifyNumber(value) {
    var numberRex = new RegExp("^[0-9]+$");
    if (numberRex.test(value)) {
      return true;
    }
    return false;
  }
  // verifies if value is a valid URL
  verifyUrl(value) {
    try {
      new URL(value);
      return true;
    } catch (_) {
      return false;
    }
  }
  */


// WEBPACK FOOTER //
// ./src/types/validationHelper.ts